import React, { useEffect, useState, useContext, useRef } from "react";
import { Typography, Stack, Box, Grid, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import moment from "moment";
//Icons

//Srcs
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import { GET_REMAINING_PAYMENT_BY_CLASS_GROUP_REPORT } from "../../Schema/Report";

import StudentPayment from "./StudentPayment";
import StudentPaymentEstimate from "./StudentPaymentEstimate";

export default function StudentPaymentMainTab() {
  // Change Languag
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [classVal, setClassVal] = useState({ id: "", title: "" });
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [studentId, setStudentId] = useState("");

  const [tabValue, setTabValue] = useState("Student-Payment");

  // const [open, setOpen] = useState(false);
  // const handleOpen = (studId) => {
  //   setOpen(true);
  //   setStudentId(studId);
  // };
  // const handleClose = () => setOpen(false);

  const { refetch } = useQuery(GET_REMAINING_PAYMENT_BY_CLASS_GROUP_REPORT, {
    variables: {
      classId: classVal ? classVal?.id : "",
      keyword: "",
    },
    onCompleted: ({ getRemainingPaymentByClassReport }) => {
      // console.log(
      //   "getRemainingPaymentByClassReport::",
      //   getRemainingPaymentByClassReport
      // );
      setTableData(getRemainingPaymentByClassReport);
      setLoading(false);
    },
    onError: (error) => {
      console.log("Error::", error?.message);
      setTableData([]);
    },
  });

  useEffect(() => {
    refetch();
  }, [classVal?.id]);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="row" spacing={2}>
          <Box className="slash" />
          <Stack direction="column" justifyContent="center">
            <Link to="/report" className="page-link-title">
              <Typography className="page-title">Report</Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">Student Payment</Typography>
          </Stack>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              Student Payment
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      {/* <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack direction="row">
              <Button
                sx={{ width: "230px" }}
                onClick={() => setTabValue("Student-Payment")}
                className={
                  tabValue === "Student-Payment" ? "active-tab" : "inactive-tab"
                }
              >
                All Payment
              </Button>
              <Button
                sx={{ width: "220px" }}
                onClick={() => setTabValue("Student-Payment-B")}
                className={
                  tabValue === "Student-Payment-B"
                    ? "active-tab"
                    : "inactive-tab"
                }
              >
                Tuition Payment
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Box> */}
      <StudentPaymentEstimate /> 
      {/* {tabValue === "Student-Payment" ? <StudentPaymentEstimate /> : null}
      {tabValue === "Student-Payment-B" ? <StudentPayment /> : null} */}
    </div>
  );
}
